import React, { useState, Suspense, lazy } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    createStyles,
    ActionIcon,
    Button,
    Collapse,
    Select,
    TextInput,
    NumberInput,
    Switch,
    Radio,
    SegmentedControl,
    Card,
    Paper,
    Avatar,
    Group,
    TypographyStylesProvider,
    Text,
    Badge,
    Stack,
    Indicator
} from '@mantine/core';
import {
    DatePicker,
    DateRangePicker,
    TimeInput
} from '@mantine/dates';
import { 
    nanoid,
    unwrapResult,
} from '@reduxjs/toolkit';
import {
  IconBell,
  IconSettings,
  IconUsers,
  IconFileSettings,
  IconUserPlus,
  IconGavel,
  IconBuildingBank,
  IconRepeat,
  IconReceiptRefund,
  IconReceipt,
  IconReceiptTax,
  IconReport,
  IconCashBanknote,
  IconBook,
  IconCalendar,
  IconMessage,
} from '@tabler/icons';


import { 
    carCreatorTextInfoUpdated,
    carCreatorSelectSectionDataB,
    fetchTests,
    testPost,
    testUpload,
    selectImage
} from '../features/auctionItemMgmt/auctionItemMgmtSlice';
import { 
    fieldInfoUpdated,
    selectSectionData,
} from '../features/home/homeSlice';
//descript:here for upload tests
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';
import pagani from '../assets/pagani.jpg';


const useStyles = createStyles((theme) => ({
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    cardContent: {
        justifyContent: 'center',
        margin: '0 auto',
        textAlign: 'center'
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    },
    content: {
        '& > p:last-child': {
            marginBottom: 0,
        },
    },
    
}));


//needed: pass params to fill out the areas of the alert item
//export function SubscribersItem {
const StaffItem = ({avatar, username, name, status, lastAccess, role}) => {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    
    const component_md = {
        par: 'subscribers',
        lvl: 0,
        child: 'all',
        mode: 0,
        section: 'allSection',
    }
    //neded: status mapping as enums


    return (
        <>
            <Card shadow="sm" padding="lg" radius="md" withBorder>
                <Group position="center">
                    <Indicator color="green">
                        <Avatar src={avatar} size={120} radius={120} mx="auto"/>
                    </Indicator>
                </Group>
                
                <Text ta="center" td="underline" c="blue" fz="xl">{`@${username}`}</Text>
                <br/>
                <Text>
                    Full Name: {name}
                </Text>
                <br/>
                <Text>
                    Last Access: {lastAccess}
                </Text>
                <br/>
                <Text>
                    Staff Role: {role}
                </Text>
                <br/>
                <Badge fz="lg" ta="center" color="green" fullWidth>
                    {status}
                </Badge>
            </Card>
        </>
    );
    
}
export default StaffItem
